/** @typedef {{
 *     onShow: (JQLite, any) => void,
 *     onShown: (JQLite, any) => void,
 *     onHide: (JQLite, any) => void,
 *     onHidden: (JQLite, any) => void,
 *     options: string,
 *     modal: string
 * }} ModalOptions */

var Modal = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */

    const defaultModalOptions = {
        onShow: function () { },
        onShown: function () { },
        onHide: function () { },
        onHidden: function () { },
        options: "show",
        modal: '#FD_MODAL'
    };
    let modalLock = false;

    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */

    /**
     * @callback AjaxCallback
     * @param {any} result
     * @param {JQLite} $modal
     */

    /**
     * @param {string} html
     * @param {ModalOptions} modalOptions
     * @param {any} result The ajax result object that led to showing the modal
     * @param {AjaxCallback} callbackBeforeShow The callback to execute before showing the modal
     * @param {boolean} forceOpen If another modal is open and this is set to true, this modal will open anyway.
     * @returns {JQLite}
     */
    function showModal(html, modalOptions, result, callbackBeforeShow, forceOpen) {
        let locked = modalLock;
        if (locked && !forceOpen) {
            return null;
        }
        modalLock = true;
        modalOptions = $.extend({}, defaultModalOptions, modalOptions);

        /** @type JQLite */
        const $modal = $(modalOptions.modal).html(html)

        // Add onCreate hook so images can be inserted before modal starts fading in. Prevents FOUC
        if (modalOptions.onCreate) {
            modalOptions.onCreate($modal)
        }

        $modal.enableControls()
            .on('show.bs.modal', function () {
                if (modalOptions.onShow) {
                    modalOptions.onShow($modal, result);
                }
                $modal.off('show.bs.modal');
            })
            .on('shown.bs.modal', function () {
                if ($(".modal:visible").length > 1) {
                    $(".modal:visible").not($modal).addClass('modal-disabled');
                }
                $('[data-fd-control="textarea"]', $modal).control_textarea('resize');
                $('[autofocus]', $modal).focus();

                if (modalOptions.onShown) {
                    modalOptions.onShown($modal, result);
                }
                $modal.off('shown.bs.modal');
            })
            .on('hide.bs.modal', function () {
                $('form', $modal).dirtyForms('setClean');

                if (modalOptions.onHide) {
                    modalOptions.onHide($modal, result);
                }
                $modal.off('hide.bs.modal');
            })
            .on('hidden.bs.modal', function () {
                if ($(".modal:visible").length > 0) {
                    $(".modal:visible").not($modal).last().removeClass('modal-disabled');
                    $('body').addClass('modal-open');
                } else {
                    modalLock = false; // release lock before onHidden in order to open another modal on callback if wanted
                }
                if (modalOptions.onHidden) {
                    modalOptions.onHidden($modal, result);
                }
                $modal.off('hidden.bs.modal');
            });

        if (callbackBeforeShow) {
            callbackBeforeShow(result, $modal);
        }

        if (locked && !forceOpen) {
            return $modal;
        }

        return modalOptions.options ? $modal.modal(modalOptions.options) : $modal.modal("show");
    }

    /* ========================================================================
     *  Public Members
     * ========================================================================
    */

    return {
        /**
         * @param {AjaxOptions} ajaxOptions
         * @param {ModalOptions} modalOptions
         * @param {boolean} forceOpen
         */
        fdAjax: function (ajaxOptions, modalOptions, forceOpen) {
            if (modalLock) {
                return;
            }
            modalLock = true;

            const currentCallback = ajaxOptions.callback;
            ajaxOptions.callback = function (result) {
                if (result.data) {
                    modalLock = false;
                    showModal(result.data, modalOptions, result, currentCallback, forceOpen);
                } else {
                    modalLock = false; // release lock before onHidden in order to open another modal on callback if wanted
                    if (currentCallback) {
                        currentCallback(result);
                    }
                }
            };

            $.fdAjax(ajaxOptions);
        },


        /**
         * @param {string} html
         * @param {ModalOptions} modalOptions
         * @param {boolean} forceOpen
         */
        showModal: function (html, modalOptions, forceOpen) {
            return showModal(html, modalOptions, null, null, forceOpen);
        },

        hideModal: function () { 
            if (Modal.isOpen()) {
                $(this).closest('.modal').modal('hide');
            }
        },

        isOpen: function isOpen() {
            return modalLock;
        },

        /**
         * @param {{ responseText: string }} xhr
         */
        openModal: function (xhr, modalOptions) {
            FD.Utility.stopLadda.call(this);
            return showModal(xhr.responseText || xhr, modalOptions);
        },

        /**
         * @param {{ value: string }} data
         */
        openImageModal: function (data) {
            return showModal($("#IMAGE_MODAL").html(), {
                onShown: function ($modal) {
                    $modal.find("img").attr("src", data.value);
                }
            })
        },

        openInquireModal: function (_data, event, template = '#INQUIRE_MODAL') { 
            let featureImageUrl = "";
            let pattern = "";
            let name = "";
            const self = this;
            const data = this.element.data();

            if (data.productId) {
                featureImageUrl = data.featureImageUrl ?? data.featureImageSrc;
                pattern = data.pattern;
                name = data.name;
            }
            // Customized product
            if (this.element.closest('.product-entry').find(".product-image.semi-custom-customize").length) {
                if ($(".color-visualizer-customization").is(":visible")) {
                    const form = FD.Utility.getControlValuesByContainer("#FORM");
                    const colors = $('.palette-item .palette:visible .palette-color').map((_, s) => $(s).data('colorHex')).toArray().join('|')
                    const data = {
                        colors: colors,
                        productId: form.ProductId,
                        hasBorder: $("#FORM input[type=checkbox][name$=HasBorder]").is(':checked'),
                        format: 'svg'
                    }
                    featureImageUrl = FD.Page.colorVisualizerImageUrl + '?' + $.param(data).replaceAll("[]", '');
                }
            } else {
                // Project Page
                let url = this.element.closest('.project-item').find(".image img").attr('src');
                if (url) {
                    featureImageUrl = url;
                } else {
                    // Product Page
                    url = this.element.closest('.product-entry').find(".product-image img").attr('src');
                    if (url) {
                        featureImageUrl = url;
                    }
                }
            }

            return showModal($(template).html(), {
                onShown: function ($modal) {
                    $modal.find(`input[name$='${data.preselect}']:visible`).click();

                    if (featureImageUrl && featureImageUrl != $("#FeatureImageUrl").attr("src")) {
                        $("#FeatureImageUrl").attr("src", featureImageUrl);
                        setTimeout(() => $("#FeatureImageUrl").removeClass('d-none'), 100);
                    } else {
                        $("#FeatureImageUrl").removeClass('d-none');
                    }
                    if (pattern) {
                        $("#Pattern").text(pattern);
                    }
                    if (name) {
                        $("#Name").text(name);
                    }

                    if ($("#Inquiry_Country", $modal).val() == FD.Constant.unitedStatesCode) {
                        App.updateCityStateFromZip($("#Inquiry_ZipCode"), $("#Inquiry_City", $modal), $("#Inquiry_State", $modal));
                    }

                    $("#Inquiry_Country", $modal).change(function () {
                        $("#Inquiry_City", $modal).val('').removeClass("text-danger").attr('readonly', $(this).val() == FD.Constant.unitedStatesCode);
                        $("#Inquiry_State", $modal).val('').attr('readonly', $(this).val() == FD.Constant.unitedStatesCode);
                        $("#Inquiry_ZipCode", $modal).attr('type', $(this).val() == FD.Constant.unitedStatesCode ? 'number' : 'text').blur();


                        if ($(this).val() == FD.Constant.unitedStatesCode) {
                            App.updateCityStateFromZip($("#Inquiry_ZipCode", $modal), $("#Inquiry_City", $modal), $("#Inquiry_State", $modal));
                        }
                    });

                    $("[name$=TradeStatus]", $modal).change(function () {
                        const tradeStatus = $(this).val();
                        const valid = tradeStatus == "DesignerOrArchitect" || tradeStatus == "WorkingWithDesigner";
                        
                        $(".show-valid-trade-status", $modal).toggleClass('d-none', !valid);
                        $(".hide-valid-trade-status", $modal).toggleClass('d-none', valid);
                        $("[type=submit]", $modal).prop('disabled', !valid);                        
                    })

                    // Customized product
                    if (self.element.closest('.product-entry').find(".product-image.semi-custom-customize").length) {
                        if ($(".color-visualizer-customization").is(":visible")) {
                            $("#FORM [name$=HasBorder]").clone().appendTo("#INQUIRY_FORM");
                            $("#FORM [name$=ColorId]").clone().appendTo("#INQUIRY_FORM");

                            const hasBorder = $("#FORM [name$=HasBorder]").is(":checked");
                            $("#INQUIRY_FORM .palette-item .palette .palette-colors > *:last-child")
                                .toggleClass('d-none', !hasBorder)
                                .toggleClass('d-flex', hasBorder);

                            const selectedPalette = $("#FORM input[name$=SelectedPalette]").val()
                            var colors = $(`#FORM .palette-item .palette[data-fd-parentid='${selectedPalette}'] .palette-color`);
                            colors.each(function () {
                                const color = $(this).data('color');
                                const item = $(`#INQUIRY_FORM .palette-item .palette [data-color=${color}] .palette-color`);
                                const data = $(this).data();
                                $(item).parent().data(data);
                                $(item).css("--color", data.colorHex);
                                $(item).css("--border-color", data.borderColor);
                            });
                        }
                    } else {
                        // Project Page
                        $("[name$=HasBorder]", self.element.closest('.project-item')).clone().appendTo("#INQUIRY_FORM");
                        $("[name$=ColorId]", self.element.closest('.project-item')).clone().appendTo("#INQUIRY_FORM");
                        $("#INQUIRY_FORM [name$=ProductId]").val(data.productId);
                    }
                }
            });
        },

        openRequestASampleModal: function (data, event) {
            return FD.Modal.openInquireModal.call(this, data, event, "#REQUEST_A_SAMPLE_MODAL");
        },

        /** @param {{value: { preselect: string, productId?: number }}} data */
        openPomRequestModal: function (data) {
            return showModal($("#NEW_POM_MODAL").html(), {
                onShown: function ($modal) {
                    const form = $('#NEW_POM_FORM');
                    if ($("select[name$=Country]", form).val() == FD.Constant.unitedStatesCode) {
                        App.updateCityStateFromZip($("#PomRequest_ZipCode"), $("#PomRequest_City"), $("#PomRequest_State"), $("#CITY_STATE"));
                    }
                }
            });
        },

        /**
         * @param {{ value: string }} data
         */
        openImageModal: function (data) {
            return showModal($("#IMAGE_MODAL").html(), {
                onShown: function ($modal) {
                    $modal.find("img").attr("src", data.value);
                }
            })
        },
        sendMessage: function () {
            $("[data-toggle-display]", "#AskAnExpertModal").toggleClass("d-none");

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({ 'event': 'ask-an-expert-success' });
            }
        }
    };
}();